import type {
  ContentObject,
  ContentTypePropertyConfig,
  ContentTypePropertySchema,
  WithOptionalInternalProps,
} from '../../../lib/flotiq-client/types/api-response';

import * as Y from 'yjs';

import { syncYjsEntry } from '../../../form-hooks/collaboration/syncYjs';

export const getInitialData = (
  properties: Record<string, ContentTypePropertyConfig>,
  schema: Record<string, ContentTypePropertySchema>,
  contentObject: WithOptionalInternalProps<ContentObject> | undefined | null,
  isExistingObject = false,
  yjsDocument?: Y.Doc,
) => {
  const doc = yjsDocument || new Y.Doc();
  const yMap = doc.getMap('vals');
  doc.transact(() => {
    Object.keys(schema).forEach((key) => {
      if (!yMap.has(key)) {
        syncYjsEntry(
          yMap,
          key,
          schema[key],
          properties?.[key],
          contentObject?.[key],
          !isExistingObject,
        );
      }
    });
  });
  return yMap.toJSON() as WithOptionalInternalProps<ContentObject>;
};
